import type {
  TCompradorPropostaSchema,
  TClientePessoaFisicaPropostaSchema,
  TClientePessoaJuridicaPropostaSchema,
} from '@/features/proposta/brasil/domain/schemas'
import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'

const converterVinculos = (
  vinculos: TCompradorPropostaSchema['vinculos'],
  clientesPF: TClientePessoaFisicaPropostaSchema[],
) => {
  return vinculos.map((vinculo) => {
    const clientePF = clientesPF.find((cliente) => cliente.id === vinculo.clienteId)!
    return {
      id: clientePF.id,
      nome: clientePF.nome,
      documento: clientePF.cpf,
      tipo: vinculo.tipo,
      maiorDe18Anos: true,
      vinculos: [],
    }
  })
}

export const obterTodosCompradoresPFEPJ = (
  compradores: TCompradorPropostaSchema[],
  clientesPF: TClientePessoaFisicaPropostaSchema[],
  clientesPJ: TClientePessoaJuridicaPropostaSchema[],
): TCompradoresCadastrados => {
  return compradores.map((comprador) => {
    if (comprador.tipo === 'PessoaFisica') {
      const clientePF = clientesPF.find((cliente) => cliente.id === comprador.clienteId)
      return {
        documento: clientePF!.cpf,
        id: clientePF!.id,
        nome: clientePF!.nome,
        tipo: 'PessoaFisica',
        maiorDe18Anos: clientePF!.maiorDe18Anos,
        vinculos: converterVinculos(comprador.vinculos, clientesPF),
      }
    }

    const clientePJ = clientesPJ.find((cliente) => cliente.id === comprador.clienteId)
    return {
      documento: clientePJ!.cnpj,
      id: clientePJ!.id,
      nome: clientePJ!.razaoSocial,
      tipo: 'PessoaJuridica',
      maiorDe18Anos: null,
      vinculos: converterVinculos(comprador.vinculos, clientesPF),
    }
  })
}
